import React from "react";
import { Row, Col, InputGroup, Form } from "react-bootstrap";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";

const SearchFilterBar = ({
  searchTerm = "",
  setSearchTerm = () => {},
  filterValue = "All",
  setFilterValue = () => {},
  filterOptions = [],
  placeholder = "Search..."
}) => {
  return (
    <Row className="mb-3 align-items-center">
      {/* Search Input */}
      <Col md={6}>
        <InputGroup>
          <InputGroup.Text>
            <SearchIcon />
          </InputGroup.Text>
          <Form.Control
            type="text"
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
      </Col>

      {/* Filter Dropdown */}
      {filterOptions.length > 0 && (
        <Col md={3}>
          <InputGroup>
            <InputGroup.Text>
              <FilterListIcon />
            </InputGroup.Text>
            <Form.Control
              as="select"
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
            >
              <option value="All">All</option>
              {filterOptions.map((opt, idx) => (
                <option key={idx} value={opt}>
                  {opt}
                </option>
              ))}
            </Form.Control>
          </InputGroup>
        </Col>
      )}
    </Row>
  );
};

export default SearchFilterBar;
